


















import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import * as def from "@/definitions";

import { Layer } from "@/model/document2/page/surface/design/layer/layer";
import { GroupLayer } from "@/model/document2/page/surface/design/layer/groupLayer";

import { Treenode } from "@/definitions/treenode"

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
  components: {
  }
})
export default class GroupLayerView extends Vue {
    
  @Prop()
  private treeNode!: Treenode;

  getResource(file : string){
        return ResourceHelper.getResource(file);
    }

}
